<template>
  <div
    :class="[
      'parentContainer',
      zeroPadding ? 'noPadding dialog-global' : 'dialog-global',
      showHeader ? '' : 'noHeaderParentDiv',
      isDrilldown || !dialogTitle ? 'flag-dialog' : ''
    ]">
    <CustomOverLay v-if="!isModal || !isModalAppend" :showOverlay="dialogVisible" />
    <el-dialog 
      :title="dialogTitle" 
      :model-value="dialogVisible" 
      :width="width" 
      :lock-scroll="true"
      :close-on-click-modal="onClickClose" 
      :modal="isModal" 
      align-center 
      @close="handleClose">
      
      <div v-loading="loading" :style="dialogBodyStyle" class="dialog-body">
        <slot name="body">
          <div class="dialog-content">
            
            <!-- Head Slot -->
            <slot name="head"> 
              <h4 class="dialog-title"></h4>
            </slot>

            <!-- Image Slot -->
            <slot name="image">
              <img v-if="false" :src="''" alt="Warning" class="dialog-image" />
            </slot>
            
            <!-- Text Content -->
            <slot name="text">
              <span>This is a message</span>
            </slot>
          </div>
        </slot>
      </div>

      <!-- Footer Slot -->
      <template v-if="isDefaultFooterNeeded" #footer>
        <slot name="footer">
          <div class="dialog-footer" :class="{ onlyOneButton: removeCancel }">
            <el-button v-if="!removeCancel" @click="handleClose">{{ cancelButtonText }}</el-button>
            <el-button :type="footerButtonType" @click="handleClick" :disabled="disableButton">
              {{ footerButtonText }}
            </el-button>
          </div>
        </slot>
      </template>
    </el-dialog>
  </div>
</template>
  
  <script>
  import CustomOverLay from './customOverLay.vue';
  
  export default {
    name: "MessageBox",
    components:{CustomOverLay},
    props: {
      dialogTitle: {
        type: String,
        default: "",
      },
      height:{
        type:String,
        default:'auto'
  
      },
      onClickClose: {
        type: Boolean,
        default: true,
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      footerButtonText: {
        type: String,
        default: "Confirm",
        required: false,
      },
      width: {
        type: String,
        default: "30%",
        required: false,
      },
      footerButtonType: {
        type: String,
        default: "primary", 
        required: false,
      },
      removeCancel: {
        type: Boolean,
        default: false,
        required: false,
      },
      disableButton: {
        type: Boolean,
        default: false,
        required: false,
      },
      isDrilldown: {
        type: Boolean,
        default: false,
      },
      loading:{
        type:Boolean,
        default:false
      },
      isModal:{
        type:Boolean,
        default:true
      },
      zeroPadding:{
        type:Boolean,
        default:false
      },
      isModalAppend:{
        type:Boolean,
        default:true
      },
      isDefaultFooterNeeded:{
        type:Boolean,
        default:true,
      },
      showHeader: {
        type: Boolean,
        default: true
      },
      cancelButtonText: {
        type: String,
        default: "Cancel",
        required: false,
      }
    },
    emits: ["handleClose", "handleClick"],
    computed: {
      dialogBodyStyle() {
        if (this.height) {
          return {
            height: this.height,
            margin: 'auto',
            // overflowY: 'scroll',
            // overflowX: 'hidden'
          };
        }
        return {}
      },
    },
    methods: {
      handleClose() {
        this.$emit("handleClose");
      },
      handleClick() {
        this.$emit("handleClick");
        this.$emit("handleClose",'click');
      },
    },
  };
  </script>
  <style scoped>
  .dialog-global :deep() .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;
    border-radius: 8px;
  
  }
  .dialog-global :deep() .el-dialog {
    border-radius: 1rem;
    width: 454px;
  }
  .parentContainer :deep() .el-dialog__header {
    background-color: #e8edf2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px 8px 0 0;
    padding:10px !important
  }
  .parentContainer :deep() .el-dialog__body {
      /* padding: 30px 20px; */
      color: #222;
      overflow-y: auto;
      /* font-size: 14px;
      word-break: break-all; */
  }
  .flag-dialog :deep() .el-dialog__header,
  .noHeaderParentDiv :deep() .el-dialog__header {
    display: none;
  }
  
  .parentContainer :deep() .el-dialog__title {
    color: #222222 !important;
    font-size: 1rem;
    font-weight: 600;
  }
  .parentContainer :deep() .el-dialog__headerbtn .el-dialog__close{
  font-size: 1.5rem;
  font-weight: 600;
  color:black
  }
  .parentContainer :deep() .el-dialog__headerbtn .el-dialog__close:hover {
    color: #000 !important; /* Change the color on hover */
  }
  .parentContainer :deep() .el-dialog__body{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 1.5rem;
  }

  .parentContainer :deep() .el-dialog__body .dialog-body .dialog-content{
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .parentContainer :deep() .el-dialog__body .dialog-body .dialog-content img{
    height: 90px;
  }
  
  .parentContainer :deep() .el-dialog__body .dialog-body .dialog-content .dialog-title{
    padding: 0 1rem;
    width: 100%;
    text-align: center;
    line-height: normal;
    font-size: 20px;
    font-weight: 900;
  }


  .parentContainer :deep() .el-dialog__body p{
    display: flex;
    height: 90%;
    text-align: center;
    margin: auto;
    font-size: 18px;
    white-space: pre-line;
    line-height: 1.6;
    color: #000;
    font-weight: 500;
    padding: 0 1rem;
  }
  .parentContainer :deep() .el-dialog__footer {
    margin: 0;
    padding: 0;
  }

  .parentContainer :deep() .el-dialog__footer div{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-radius: 0 0 1rem 1rem;
    overflow: hidden;
    background-color: #fff;
    column-gap: 1px;
  }

  .parentContainer :deep() .el-dialog__footer .onlyOneButton{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    border-radius: 0 0 1rem 1rem;
    overflow: hidden;
    background-color: #fff;
    column-gap: 1px;
  }

  .parentContainer :deep() .el-dialog__footer button{
    border: 0;
    font-size: 1rem;
    border-top: 1px solid #e0e0e0;
    cursor: pointer;
    font-weight: 700;
    outline: none;
    color: #ffffff;
    background-color: #409EFF;
    min-height: 50px;
    margin-left: 0px;
    border-radius: 0;
  }
  </style>
  
